@if (isLoginVisible) {
  <div class="login-container">
    @if (!isPreLoginPostBack) {
      <mat-card class="login-card">
        <div class="logo">
          <img class="logo-image" src="../../../assets/images/logos/MilanaLogoDark.png" alt="Logo">
        </div>
        <!-- Validation Message Section -->
        @if (validationMessage) {
          <div class="validation-message" [@slideInOut]>
            {{ validationMessage }}
          </div>
        }
        <form [formGroup]="emailForm" class="email-form" (ngSubmit)="getIdentityUserType()">
          <mat-label>Email</mat-label>
          <mat-form-field appearance="outline" class="full-width form-margin">
            <input matInput formControlName="email" type="email" required (keydown.space)="$event.preventDefault()"
              (input)="removeSpaces($event)" />
            </mat-form-field>
            <mat-checkbox formControlName="rememberMe" style="display: none;">Remember Me</mat-checkbox>
            <button mat-raised-button color="primary" class="full-width">Continue</button>
          </form>
        </mat-card>
      }
      @if (isPreLoginPostBack) {
        <div class="login-card-loading">
          <fuse-splash-screen id="fuse-splash-screen">
            <div class="center" fxLayout="row">
              <!-- Material Design Spinner -->
              <div class="spinner-wrapper">
                <div class="spinner">
                  <div class="inner">
                    <div class="gap"></div>
                    <div class="left">
                      <div class="half-circle"></div>
                    </div>
                    <div class="right">
                      <div class="half-circle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fuse-splash-screen>
        </div>
      }
    </div>
  }
